'use client';

import React from 'react';
import { Bleed, Box, Card, Divider, Icon, InlineStack, Text } from '@shopify/polaris';
import { AlertCircleIcon } from '@shopify/polaris-icons';

interface InputWrapperProps {
  title?: string;
  description?: string | React.ReactNode;
  isInvalid?: boolean;
  invalidText?: string;
  children: React.ReactNode;
}

function InputWrapperBase({ title, description, isInvalid, invalidText, children }: InputWrapperProps) {
  return (
    <Card>
      <Box paddingBlockEnd="200">
        <InlineStack gap="200">
          <Text as="h2" variant="headingMd">
            {title}
          </Text>

          {isInvalid && (
            <InlineStack gap="100" align="center">
              <Icon source={AlertCircleIcon} tone="critical" />
              <Text as="p" variant="bodyMd" tone="critical">
                {invalidText || 'Invalid field'}
              </Text>
            </InlineStack>
          )}
        </InlineStack>

        {description && (
          <Text as="p" variant="bodyMd" tone="subdued">
            {description}
          </Text>
        )}
      </Box>

      <Box paddingBlockEnd="300">
        <Bleed marginInline="400">
          <Divider />
        </Bleed>
      </Box>

      {children}
    </Card>
  );
}

export const InputWrapper = React.memo(InputWrapperBase);
